export default __webpack_public_path__ + "static/media/toggle-menu.cbd28d1f.svg";